/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Teams_Create_Team_Name_MaxInputs */



/**
* | output |
* | --- |
* | "Team name must be less than {count} characters" |
*
* @param {Teams_Create_Team_Name_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_create_team_name_max = /** @type {((inputs: Teams_Create_Team_Name_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Create_Team_Name_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Teamname darf höchstens ${i?.count} Zeichen lang sein`)
	return /** @type {LocalizedString} */ (`Team name must be less than ${i?.count} characters`)
});